import { IonIcon } from '@ionic/react'
import { useGate, useStore } from 'effector-react'
import { create, documentText } from 'ionicons/icons'
import { closeDocumentsDrawer } from '~/widgets/Documents/model'
import {
  rentalContractModel,
  useRentalContractStatus,
} from '~/entities/RentalContract'
import { rentalContractStatusEnumLabels } from '~/shared/config/constants'
import { formatDateForUI } from '~/shared/lib/date'
import { pushFx } from '~/shared/lib/history'
import { Button } from '~/shared/ui/Buttons'
import { Skeleton } from '~/shared/ui/SkeletonList'
import { myPalette } from '~/shared/ui/theme'
import { Card, TitleWrapper } from '../styled'
import {
  Gate,
  loadRentalContractConfirmFile,
  loadRentalContractConfirmFileFx,
  loadRentalContractFile,
  loadRentalContractFileFx,
} from './model'
import {
  ButtonSigningWrapper,
  ButtonWrapper,
  CreatedAt,
  Title,
  WaitingSigningTitle,
} from './styled'

export function RentalContract() {
  useGate(Gate)

  const isFetchRentalContractPending = useStore(
    rentalContractModel.getRentalContractFx.pending,
  )
  const rentalContract = useStore(rentalContractModel.$rentalContract)
  const isRentalContractFilePending = useStore(loadRentalContractFileFx.pending)
  const isRentalContractConfirmFilePending = useStore(
    loadRentalContractConfirmFileFx.pending,
  )

  const createdAd = rentalContract?.getCreatedAt()
  const status = rentalContract?.getStatus()
  const signedAt = rentalContract?.getSignedAt()

  const { isSigning, isSigned, isActive, isSuspended } =
    useRentalContractStatus()

  const isSignatureButtonShow =
    signedAt && (isSigned || isActive || isSuspended)

  const handleGoToSigning = () => {
    closeDocumentsDrawer()
    pushFx('/rental-contract-signing')
  }

  return (
    <Card>
      <TitleWrapper>
        <Title>Договор</Title>

        {createdAd && <CreatedAt>От {formatDateForUI(createdAd)}</CreatedAt>}
      </TitleWrapper>

      {!isFetchRentalContractPending && !rentalContract && (
        <div>Договора нет</div>
      )}

      {isFetchRentalContractPending && <Skeleton animated $height={32} />}

      {!isFetchRentalContractPending && rentalContract && (
        <>
          <ButtonSigningWrapper>
            {status && (isSigning || isSigned || isActive || isSuspended) ? (
              <WaitingSigningTitle
                $chipColor={
                  isSigning ? myPalette.coral.main : myPalette.limeGreen.main
                }
              >
                {rentalContractStatusEnumLabels[status]}
              </WaitingSigningTitle>
            ) : (
              <div />
            )}

            <ButtonWrapper>
              {isSigning && (
                <Button
                  variant='limeFlooded'
                  onClick={handleGoToSigning}
                  contentProps={{ style: { padding: '8px' } }}
                >
                  Подписать
                </Button>
              )}

              {isSignatureButtonShow && (
                <Button
                  variant='lightSteelBlueBorder'
                  onClick={() => loadRentalContractConfirmFile()}
                  loading={isRentalContractConfirmFilePending}
                  endDecorator={
                    <IonIcon
                      icon={create}
                      style={{ width: '16px', height: '16px' }}
                    />
                  }
                  contentProps={{ style: { padding: '8px' } }}
                >
                  Подпись
                </Button>
              )}

              <Button
                variant='limeFlooded'
                onClick={() => loadRentalContractFile()}
                loading={isRentalContractFilePending}
                endDecorator={
                  <IonIcon
                    icon={documentText}
                    style={{ width: '16px', height: '16px' }}
                  />
                }
                contentProps={{ style: { padding: '8px' } }}
              >
                Договор
              </Button>
            </ButtonWrapper>
          </ButtonSigningWrapper>
        </>
      )}
    </Card>
  )
}
